module.exports = __webpack_public_path__ + "static/img/DE@3x.240e91f2.jpg";